<template>
    <div class="new">
        <div class="new-list">
            <div class="header">
                <div class="type-btn active" @click="getNewsAll($event)">{{$t("new.all")}}</div>
                <div class="type-btn" @click="getNewsTg($event)">{{$t("new.tz")}}</div>
                <div class="type-btn" @click="getNewsWh($event)">{{$t("new.wh")}}</div>
                <div class="type-btn" @click="getNewsHd($event)">{{$t("new.hd")}}</div>
            </div>
            <div class="list">
                <div
                    class="item"
                    v-for="news in new_list"
                    :key="news.nid"
                    @click="getNewDetail(news.nid)"
                >
                    <div class="item-top">
                        <span class="time">
                            {{news.time}}
                            <b v-if="news.istop=='1'" class="top-tip">{{ top }}</b>
                        </span>
                        <span :class="{'unread':news.redtitle=='1'}"></span>
                    </div>
                    <div class="item-cont">
                        <span>{{news.title}}</span>
                        <span class="todet"></span>
                    </div>
                </div>
            </div>
            <div class="new-footer">
                <div class="change-page">
                    <span @click="prevPage">{{$t("new.prev")}}</span>
                    <span @click="nextPage">{{$t("new.next")}}</span>
                </div>
                <router-link class="to-index" to="/index">{{$t("home")}}</router-link>
            </div>
        </div>
    </div>
</template>

<script>
import { getNewsList } from "@/api/article.js";

export default {
    name: "NewList",
    props: {
        isMobile: {
            type: Boolean,
            default: false,
        },
        cdnPrefix: {
            type: String,
            default: "",
        },
    },
    data() {
        return {
            type: 0,
            lang: window.localStorage.getItem("localeLanguage"),
            new_list: [
                // { time: "2021-04-20", title: "标题", istop: true },
                // { time: "2021-04-20", title: "标题", istop: true },
                // { time: "2021-04-20", title: "标题", istop: true },
                // { time: "2021-04-20", title: "标题", istop: false },
                // { time: "2021-04-20", title: "标题", istop: false },
            ],
            new_list_total: 0,
            limit: 10,
            pages: 1,
            current: 1,
        };
    },
    computed: {
        top() {
            let lang = this.lang;
            if (lang == "zh-CN") {
                return "置顶";
            } else if (lang == "th") {
                return "ปักหมุด"
            } else {
                return "TOP";
            }
        },
    },
    mounted() {
        console.log(this.lang);
        this.getNewsAll();
    },
    methods: {
        // 全部
        getNewsAll(e) {
            if (e) {
                this.changeBtn(e);
            }
            this.type = 0;
            this.current = 1;
            this.getNewsByType();
        },
        // 通知
        getNewsTg(e) {
            this.changeBtn(e);
            this.type = 1;
            this.current = 1;
            this.getNewsByType();
        },
        // 维护
        getNewsWh(e) {
            this.changeBtn(e);
            this.type = 2;
            this.current = 1;
            this.getNewsByType();
        },
        // 活动
        getNewsHd(e) {
            this.changeBtn(e);
            this.type = 3;
            this.current = 1;
            this.getNewsByType();
        },
        // 获取新闻
        getNewsByType() {
            getNewsList({
                lang: this.switchLang(this.lang),
                type: this.type,
                current: this.current,
            })
                .then((res) => {
                    if (res.status == 200) {
                        this.new_list_total = res.data[1];
                        this.new_list = res.data[2];
                        this.pages =
                            parseInt(this.new_list_total / this.limit) +
                            (this.new_list_total % this.limit > 0 ? 1 : 0);
                    }
                })
                .catch((msg) => {
                    console.log(msg);
                });
        },
        switchLang(lang) {
            let langtype;
            switch (lang) {
                case "zh-CN":
                    langtype = 1;
                    break;
                case "ja":
                    langtype = 3;
                    break;
                case "en":
                    langtype = 4;
                    break;
                case "th":
                    langtype = 5;
                    break;
                default:
                    langtype = 1;
            }
            return langtype;
        },
        changeBtn(e) {
            $(".new .header .type-btn").removeClass("active");
            $(e.currentTarget).addClass("active");
        },
        // 上一页
        prevPage() {
            if (this.current > 1) {
                this.current--;
                this.getNewsByType();
            }
        },
        nextPage() {
            if (this.current < this.pages) {
                this.current++;
                this.getNewsByType();
            }
        },
        // 路由跳转到 新闻详细页面
        getNewDetail(id) {
            let nid = id;
            this.$router.push({
                name: "new_detail",
                params: {
                    nid: nid,
                },
                query: {
                    nid: nid,
                },
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.top-tip {
    margin-left: 10px;
    color: #000;
    font-size: 14px;
    position: relative;
    top: -3px;
    animation: blink 1s ease-in-out infinite;
}
@keyframes blink {
    0% {
        color: rgba(#000, 1);
    }
    50% {
        color: rgba(#f00, 1);
    }
    100% {
        color: rgba(#000, 1);
    }
}
.new {
    width: 100%;
    padding: 40px 0;
    display: flex;
    justify-content: center;
    .new-list {
        width: 60%;
        .header {
            width: 90%;
            margin: 0 auto;
            display: flex;
            justify-content: space-between;
            .type-btn {
                color: #fff4d8;
                background: url($cdnPrefix + "/imgs/sec-btn.png") no-repeat;
                background-size: 100% 100%;
                padding: 10px 0;
                text-align: center;
                cursor: pointer;
                min-width: 20%;
                height: 50px;
                line-height: 30px;
                font-size: 1.2em;
            }
            .type-btn.active {
                background: url($cdnPrefix + "/imgs/sec-btn-active.png")
                    no-repeat;
                background-size: 100% 100%;
            }
        }
        .list {
            margin-top: 20px;
            min-height: 300px;
            .item {
                margin: 10px 0;
                background: url($cdnPrefix + "/imgs/new-item-bg.png") center top
                    no-repeat;
                background-size: 100% 100%;
                padding: 5px 20px 15px;
                cursor: pointer;
                .unread {
                    display: block;
                    width: 10px;
                    height: 10px;
                    float: right;
                    background: url($cdnPrefix + "/imgs/new-item-unread.png")
                        no-repeat;
                    background-size: 100% 100%;
                }
                .item-cont {
                    font-weight: bold;
                    .todet {
                        display: block;
                        width: 10px;
                        height: 20px;
                        float: right;
                        background: url($cdnPrefix + "/imgs/new-item-todet.png")
                            no-repeat;
                        background-size: 100% 100%;
                        position: relative;
                        right: 5px;
                        bottom: 3px;
                    }
                }
            }
        }
        .new-footer {
            display: flex;
            justify-content: center;
            .change-page {
                display: flex;
                justify-content: center;
                margin-right: 40px;
            }
            .change-page span,
            .to-index {
                display: block;
                color: #fff;
                padding: 5px 20px;
                margin: 0 10px;
                background: url($cdnPrefix + "/imgs/sec-btn.png") no-repeat;
                background-size: 100% 100%;
                cursor: pointer;
                opacity: 0.8;
            }
            .change-page span:hover,
            .to-index:hover {
                opacity: 1;
            }
            .to-index {
                padding: 5px 30px;
            }
        }
    }
}
// 适配小屏
@media screen and (max-width: 768px) {
    .new {
        padding: 20px 0;
        .new-list {
            width: 95%;
            .header {
                .type-btn {
                    height: 30px;
                    line-height: 30px;
                    padding: 0 5px;
                    font-size: 14px;
                }
            }
            .new-footer {
                .change-page span,
                .to-index {
                    padding: 5px 10px;
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/New_list.vue